import { AppShellTrigger, Box, useIsMobile } from "@salestrak/ui";
import * as React from "react";

export const SettingsMobileHeaderContext = React.createContext(false);

/**
 * Mobile-only settings page header: just the drawer toggle. The settings
 * sidebar's own "← Settings" title row is the way back to the app, so no
 * back affordance is duplicated here.
 */
export function SettingsMobileHeader() {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <Box
      align="center"
      background="sidebar"
      border="bottom"
      direction="row"
      paddingX="md"
      paddingY="sm"
    >
      <AppShellTrigger />
    </Box>
  );
}
